// @ts-nocheck
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
  IconButton,
  List,
  Tooltip,
  useTheme,
  alpha,
} from '@mui/material';
import { ReactComponent as CloseIcon } from '../../../../../assets/Icons/lucideIcons/x.svg';
import { ReactComponent as AddIcon } from '../../../../../assets/Icons/lucideIcons/plus.svg';

import {
  useTableState,
  useTableDispatch,
} from '../../../context/TableSchemaBuilderContext';
import RuleEditor from './RuleEditor';

const ConditionalFormattingDrawer = ({ open, onClose }) => {
  const { schema, ui } = useTableState();
  const dispatch = useTableDispatch();
  const { currentCell } = ui;
  const cellRules = schema.cells[currentCell]?.conditionalRules || [];

  const theme = useTheme();

  const handleAddRule = useCallback(() => {
    dispatch({
      type: 'ADD_CONDITIONAL_RULE',
      payload: {
        cellId: currentCell,
        rule: {
          id: Date.now(),
          condition: '=',
          value: '',
          styles: {
            backgroundColor: theme?.palette?.other?.white,
            fontWeight: 'normal',
            fontStyle: 'normal',
            textDecoration: 'none',
          },
        },
      },
    });
  }, [currentCell, dispatch]);

  if (!open) {
    return null;
  }

  return (
    <Box
      onMouseDown={(e) => e.stopPropagation()}
      sx={{
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        // width: `${ui.editorWidth}px`,
        bgcolor: theme?.palette?.other?.white,
        borderLeft: `1px solid ${alpha(theme?.palette?.primary?.main, 0.1)}`,
        display: 'flex',
        flexDirection: 'column',
        zIndex: 1200,
      }}
    >
      <Box sx={{ width: 400 }}>
        <Box
          sx={{
            px: 2,
            py: 1.5,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderBottom: `1px solid ${alpha(theme?.palette?.primary?.main, 0.1)}`,
            bgcolor: alpha(theme?.palette?.primary?.main, 0.01),
          }}
        >
          <Typography variant="h6" sx={{ fontSize: '1.1rem', fontWeight: 500 }}>
            Conditional Formatting Rules
          </Typography>
          <Box>
            <IconButton size="small" onClick={onClose}>
              <CloseIcon width={18} height={18} />
            </IconButton>
          </Box>
        </Box>

        <Box
          sx={{
            p: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <Tooltip title="Add Rule">
            <IconButton size="small" onClick={handleAddRule} sx={{ mr: 1 }}>
              <AddIcon width={18} height={18} />
            </IconButton>
          </Tooltip>
        </Box>
        <List
          sx={{ p: 2, overflowY: 'auto', maxHeight: 'calc(100vh - 380px)' }}
        >
          {cellRules.length === 0 ? (
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{ textAlign: 'center' }}
            >
              No rules defined. Click the + icon to create one.
            </Typography>
          ) : (
            cellRules.map((rule) => (
              <React.Fragment key={rule.id}>
                <RuleEditor rule={rule} cellId={currentCell} />
              </React.Fragment>
            ))
          )}
        </List>
      </Box>
    </Box>
  );
};

ConditionalFormattingDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ConditionalFormattingDrawer;
